module.exports = __webpack_public_path__ + "img/step2.faef17cb.png";